import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

//commented by business requirement
// import { cookies } from '@/shared/utils/Cookie';

import { useAppSelector } from '@/shared/hooks-tmp/reduxToolkitHooks';
import { useCheckIsUserAuthorized } from '@/shared/hooks-tmp/useCheckIsUserAuthorized';
import { TITLE } from '@/shared/lib/constants/title';
import { Loader } from '@/shared/ui-tmp';

export const ProtectedRoute = () => {
  const location = useLocation();
  // const [searchParams] = useSearchParams();
  const { cognitoUser } = useAppSelector((state) => state.cognito);
  const { isUserAuthorizedChecking } = useCheckIsUserAuthorized();

  if (isUserAuthorizedChecking) {
    return <Loader />;
  }

  if (cognitoUser.isAuthorized) {
    return (
      <>
        <Helmet>
          <title>{TITLE}</title>
        </Helmet>
        <Outlet />
      </>
    );
  }

  // const featureToggle = searchParams.get('ft');
  // if (featureToggle) {
  //   cookies.set('featureToggle', featureToggle);
  // }

  return <Navigate to="/auth" state={{ from: location }} replace />;
};
